export const GET_ALL_ACTIVITIES = "GET_ALL_ACTIVITIES"
export const GET_FOLLOWED_ACTIVITIES = "GET_FOLLOWED_ACTIVITIES"
export const SUBMIT_COMMENT = "SUBMIT_COMMENT"
export const DELETE_COMMENT = "DELETE_COMMENT"
export const LIKE_POST = "LIKE_POST"
export const UNLIKE_POST = "UNLIKE_POST"
